export class LogicText {
  constructor(difference) {
    this.width = 300
    this.height = 250
    this.top = 10
    this.left = 10
    this.innerElement = "cxLogicText"
    this.content = "天上有5只鸟，地上有10棵树"
    this.textLimitLines = 1
    this.openBlankPage = true
    this.linkUrl = ""
    this.accessRulers = []
    this.fontFamily = "sans-serif"
    this.lineHeight = 34
    this.fontSize = 14
    this.fontWeight = "400"
    this.bgColor = "rgba(255,255,255,0)"
    this.color = "rgba(0, 0, 0, 0.8)"
    this.textIsThemeColor = false
    this.hoverTextIsThemeColor = false
    this.colorType = "纯色"
    this.startColor = "rgba(0, 0, 0, 0.8)"
    this.endColor = "rgba(0, 0, 0, 0.8)"
    this.colorlinearGradientAngle = 90
    this.bgType = "自定义"
    this.letterSpacing = 0
    this.fontStyle = "normal"
    this.textAlign = "left"
    this.writingMode = "horizontal-tb"
    this.rotate = 0
    this.textDecoration = "none"
    this.textIndent = 0
    this.padding = 0
    this.paddingTop = 0
    this.paddingRight = 0
    this.paddingLeft = 0
    this.paddingBottom = 0
    this.borderTypeFlag = 2
    this.borderRadius = 0
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderStyle = "solid" // solid dashed dotted
    this.borderColor = "#000000"
    this.borderWidth = 0
    this.borderIsThemeColor = false
    this.textOverFlowType = "visible"
    // 透明度
    this.opacity = 100
    // 阴影
    this.boxShadowColor = ["rgba(255,255,255,1)"]
    this.boxShadowH = [0]
    this.boxShadowV = [0]
    this.boxShadowBlur = [0]
    this.boxShadowSpread = [0]
    this.background = []
    this.animateSets = {
      animateType: 0,
      animateDirection: "无",
      animateDuration: 1.5,
      animateDelay: 0,
      hasDirection: false,
      animateTriggerNumType: "单次触发",
      animateClass: "",
      executionAnimateClass: ""
    }
    // 变量集合
    this.variableDataList = [
      // {
      //   field: "", // 字段名称
      //   variableLabel: "", // 变量名
      //   variableValue: "", // 变量唯一标识
      //   conditionList: [
      //     {
      //       type: "singleValue", // singleValue: 单值判断；range: 区间范围
      //       conditionRange: [0, 10],
      //       condition: "等于", // 条件  等于；不等于；包含；不包含；大于；小于
      //       dynamicLabel: "", // 动态数据名
      //       dynamicValue: "", // 动态数据唯一标识
      //       parameter: "", // 参数值
      //       result: "" // 结果
      //     }
      //   ]
      // }
    ]
    // 特殊条件
    this.specialCondition = [
      {
        field: "", // 字段名称
        variableLabel: "", // 变量名
        variableValue: "", // 变量唯一标识
        condition: "等于", // 条件  等于；不等于；包含；不包含；大于；小于
        parameter: "", // 参数值
        type: "hiddenPage" // 类型，hiddenPage: 隐藏页面；hiddenRow: 隐藏行
      },
      {
        field: "", // 字段名称
        variableLabel: "", // 变量名
        variableValue: "", // 变量唯一标识
        condition: "等于", // 条件  等于；不等于；包含；不包含；大于；小于
        parameter: "", // 参数值
        type: "hiddenRow" // 类型，hiddenPage: 隐藏页面；hiddenRow: 隐藏行
      }
    ]
    // 动态数据集合
    this.dynamicList = [
      // {
      //   label: "",
      //   value: ""
      // }
    ]
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.fieldList = [
      {
        label: "",
        value: ""
      }
    ]
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
